const TransferInvoiceHeader = ({ transferData }) => {
  const dateCreated = new Date(transferData.created_at)
  const formattedDate = `${dateCreated.getDate()}-${dateCreated.getMonth() + 1}-${dateCreated.getFullYear()}`
  return <>
    <div className="row invoice-header">
      <div className="col-6">
        <div className="mainbrand navbar-brand fontBold">
          <h1 className="ms-0">SJ SAMARINDA</h1>
        </div>
        <p className="small-text">Surat Jalan Mutasi Barang</p>
      </div>

      <div className="col-6 mt-4" style={{ paddingLeft: "100px" }}>
        <address className="small-text">
          <span className="label text-start">Tanggal</span> :{" "}
          {formattedDate} <br />
          <span className="label text-start">Nomor nota</span> :{" "}
          {transferData.id} <br />
          <span className="label text-start">Dari</span> :{" "}
          {transferData.from_location} <br />
          <span className="label text-start">Ke</span> :{" "}
          {transferData.to_location} <br />
        </address>
      </div>
    </div>
    <hr style={{ margin: "8px 0px 8px 0px", height: "3px" }} />
  </>
}

export default TransferInvoiceHeader
